<template>
    <td :class="{'position-absolute border-none': (item.sub_locations)}">
        <div class="trigger-hidden-content ml-1 d-inline-block">
            <span class=" button">
                <img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
            </span>
            <div class="hidden-content hc-right-bottom">
                <div>
                    <ul v-if="table_name == 'roles_permissions'" class="list-unstyled text-left">
                        <!-- Admin Login SSO -->
                        <li :class="{ 'input-disabled' : item.id == null}" v-if="user_role==='csm'"
                            class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="adminLoginSSO(item)">
                            <i class="fa fa-sign-in fa-ninja fa-ninja-black" aria-hidden="true" style="vertical-align: baseline"></i>
                            <small class="ml-1">Admin Login</small>
                        </li>

                        <li class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="$emit('showModalEditSubrole',item)">
                            <img width="12" class="mr-1 ml-1" src="../../../assets/images/icons/solid/edit.svg" /> 
                            <span>Edit</span>
                        </li>
                        <li  v-if="(user_role ==='csm' || user_role === 'organization')" class="pb-2 pt-2 d-flex align-items-center cursor-pointer">
                            <div class="trigger-hidden-content ml-1 d-inline-block">
                            <i class="fa fa-key fa-ninja fa-ninja-black" ></i>
                            <small class="ml-1">Reset Password</small> <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: baseline"></i>
                            
                            <div class="hidden-content hc-right-bottom"> 
                                <div>
                                    <ul class="list-unstyled text-left">
                                        <li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" 
                                            @click="$emit('resetPasswordSendEmail',item)">	
                                            <i class="fa fa-sms fa-ninja fa-ninja-black"></i>
                                            <small class="ml-1">Send Email</small>
                                        </li>
                                        <li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" 
                                            @click="$emit('resetPasswordPlain',item)">	
                                            <i class="fa fa-comment-dots fa-ninja fa-ninja-black"></i>
                                            <small class="ml-1">Set New Password</small>
                                        </li>
                                    </ul>
                                </div>
                            </div>			
                        </div>
                    </li>
                        <!-- <li  class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="$emit('showModalReplaceSubrole',item)">
                            <img width="5" class="mr-1 ml-1" src="../../../assets/images/icons/solid/info.svg" /> Replace
                        </li>
                        <li v-if="item.name != 'NO ROLES'" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="$emit('resetPassword',item)">
                            <img width="12" class="mr-2" src="../../../assets/images/icons/solid/redo.svg">
                            <span> Reset pass (email)</span>
                        </li>
                        <li  v-if="item.name != 'NO ROLES'" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="$emit('restorePassword',item)">
                            <img width="12" class="mr-2" src="../../../assets/images/icons/solid/redo.svg">
                            <span v-if="item.can_reset_password">Reset pass</span>
                            <span v-else>Restore pass</span>
                        </li> -->
                        <!-- <li class="pb-2 pt-2 d-flex align-items-center  cursor-pointer" v-if="item.n_hhas == 0" @click="$emit('showModalDeleteSubrole',item)">
                            <img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
                            <span> Delete</span>
                        </li>     -->
                    </ul>
                    <ul v-if="table_name == 'providers' || table_name == 'courses'" class="list-unstyled text-left">
                        

                        <li class="pb-2 pt-2 d-flex align-items-center">
                            <router-link :to="{ name :'admin.'+table_name+'.detail', params : { id : item.id, agency_id: $route.params.agency_id, section: 'detail'} }" tag="a">
                                <img width="5" class="mr-1 ml-1" src="../../../assets/images/icons/solid/info.svg" /> View details
                            </router-link>
                        </li>
                        <li v-if="table_name=='courses'" class="pb-2 pt-2 d-flex align-items-center pointer" @click="showModalMoveToCourse(item)">
                            <img width="12" class="mr-1 ml-1" src="../../../assets/images/icons/solid/arrow-right.svg"/> 
                            <span>Add HHAs to...</span>
                        </li>

                        <li v-if="user_role != 'csm' && table_name != 'providers'"
                        
                        class="pb-2 pt-2 d-flex align-items-center  cursor-pointer"  @click="showModalDeleteCourse(item)">
                            <img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
                            <span>Delete</span>
                        </li>
                        <li v-if="table_name == 'providers'" class="pb-2 pt-2 d-flex align-items-center  cursor-pointer"  @click="showModalDelete(item)">
                            <img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
                            <span> Delete</span>
                        </li>
                    </ul>
                    <ul v-if="( table_name == 'discipline' || table_name == 'location' ) && ( user_meta_actions.includes('can_create_edit_roles_users'))" class="list-unstyled text-left">
                        
                        <li class="pb-2 pt-2 d-flex align-items-center cursor-pointer"  @click="$emit('modalEditTaxonomyValue',table_name,item)">
                            <img width="12" class="mr-1 ml-1" src="../../../assets/images/icons/solid/edit.svg" /> 
                            <span>Edit</span>
                        </li>
                        
                        <li class="pb-2 pt-2 d-flex align-items-center  cursor-pointer" @click="$emit('modalDeleteTaxonomyValue',table_name,item)">
                            <img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
                            <span> Delete</span>
                        </li>
                        <li v-if="table_name == 'location'" class="pb-2 pt-2 d-flex align-items-center  cursor-pointer" @click="$emit('openAddModal','Add Sub Location','Location', item)">
                           	<img width="12" class="mr-2" src="../../../assets/images/icons/solid/plus.svg" />
                            <span> Add </span>
                        </li>
                        
                    </ul>
                    <ul v-if="( table_name == 'sub_locations' ) && ( user_meta_actions.includes('can_create_edit_roles_users'))" class="list-unstyled text-left">
                        
                        <li class="pb-2 pt-2 d-flex align-items-center cursor-pointer"  @click="$emit('openEditModal', item, parent_subject, 'Edit Sub Location', 'Location', false)">
                            <img width="12" class="mr-1 ml-1" src="../../../assets/images/icons/solid/edit.svg" /> 
                            <span>Edit</span>
                        </li>
                        
                        <li class="pb-2 pt-2 d-flex align-items-center  cursor-pointer" @click="$emit('openEditModal', item, parent_subject, 'Delete Sub Location', 'Location', true)">
                            <img width="12" class="mr-2" src="../../../assets/images/icons/solid/trash.svg">
                            <span> Delete</span>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>	
    </td>
    
</template>
<script>

export default{
    props:['table_name', 'item', 'subrole', 'parent_subject'],
    data: function(){
        return{
            user_role : this.$store.getters.getRole,
            user_meta_actions: localStorage.getItem('meta_actions')
        }
    },
    computed:{
      
    },
    methods:{
        showModalMoveToCourse(item){
            this.$emit('showModalMoveToCourse',item)
        },
        showModalDeleteCourse(item){
            this.$emit('showModalDeleteCourse',item)
        },
        showModalDelete(item){
            this.$emit('showModalDelete',item)
        },
        adminLoginSSO(userData) {
            console.log("Admin Login SSO Clicked");
            var current_url = window.location.href;
            var agency_id = current_url.replace(/\D/g, '');
            if (agency_id.length > 4) {
                agency_id = agency_id.slice(4);
            }
            console.log("ORG ID FROM URL: ", agency_id);
            var params = {
                agency_id : agency_id,
                user_id : userData.id
            }

            this.$store.dispatch('loginAsAdminSSO', params).then((res) => {
                if(res.data.url){
                    window.open(res.data.url, '_blank');
                }
            }).catch((error) => {
                console.log(error);
            })
        },

    }
    
}
</script>
<style>
.border-none{
    border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/profile/TableViewActions.vue